import SendReports from "@/models/supplierPanel/SendReports";

export default {
    namespaced: true,

    state: () => ({
        supplierGifts: [],
        uploadingFile: null
    }),

    mutations: {
        setSupplierGifts(state, payload) {
            state.supplierGifts = payload;
        },
        setUploadingFile(state, payload) {
            state.uploadingFile = payload;
        }
    },

    actions: {
        async getSupplierGifts({ commit }, body) {
            try {
                commit("setLoading", true, { root: true });

                const { data } = await SendReports.get(body.query,body.status);
                const { pagination } = data.data

                commit("setSupplierGifts", data.data.data);
                commit("setServerItemsLength", pagination.total, {
                    root: true
                });
                commit("setServerPagination", pagination, {
                    root: true
                });
                commit("setLoading", false, { root: true });
            } catch (ex) {
                commit("setLoading", false, { root: true });
            }
        },

        async uploadFile({ commit,state,dispatch }, id) {
            try {
                commit("setLoading", true, { root: true });
                if(state.uploadingFile){
                    const fd = new FormData();
                    fd.append("invoice", state.uploadingFile);
                    await SendReports.uploadFile(id, fd);
                    dispatch("getSupplierGifts", {
                        query: `?page=1`,
                        status: 6,
                    })
                    commit("setDialog", false, { root: true });
                    commit(
                        "setNotification",
                        {
                            show: true,
                            type: "success",
                            text: "You have successfully uploaded file!"
                        },
    
                        { root: true }
                    );
                }
                commit("setLoading", false, { root: true });               
            } catch (ex) {
                commit("setLoading", false, { root: true });
                commit(
                    "setNotification",
                    {
                        show: true,
                        type: "error",
                        text: ex.response.data.message
                    },

                    { root: true }
                );
            }
        },
    }
};
